export interface IRefreshInterval {
    value: number;
    label: string;
}